// extracted by mini-css-extract-plugin
export default {"img":"XF+jrb+nYtpghNMrtigIIw==","container":"jS0gdHsEqLKgoIxXqr1wxg=="};